import * as React from "react";
import {Actions, ActionsEnum} from "../../../processes/massive_actions/CensusCooler/data/models/CensusEnums";
import {JSONCensusEquipment} from "../../../processes/massive_actions/CensusCooler/data/models/JSONCensusEquipment";
import {EquipmentWithSuggestedAndFinalAction} from "./types";
import {EQ_TABLES_INDEXES, EQ_TABLES_NAMES} from "../../../processes/massive_actions/CensusCooler/types";
import {Column} from "react-table";
import {getFormattedDate} from "../../../ReadAndWrite/ReadAndWrite/utils";
import './styles.scss';
import {delay} from "@vebox/etui-core";

const valueOrDefault = (value: string | undefined): string => value ?? "-";

export const createDatasource = (
    list: JSONCensusEquipment[],
    translatedActionsEnum: Actions,
    stackManager: any,
    toggleDrawer: () => void,
    updateOpenLevel: (open: boolean) => void,
    updateNavigateToCensusDetail: (value: boolean) => void,
): EquipmentWithSuggestedAndFinalAction[] => {
    return list?.map((jsonCensusEquipment: JSONCensusEquipment) => {
        const equipment = jsonCensusEquipment.equipmentInfo;

        let action = valueOrDefault(
            translatedActionsEnum[jsonCensusEquipment.suggestedAction] ?? jsonCensusEquipment.suggestedAction);

        if (action === '-' && jsonCensusEquipment.finalAction) {
            action = translatedActionsEnum[ActionsEnum.NO_ACTION]
        }

        const onclick = () => {
            toggleDrawer()
            delay(550)
                .then(() => {
                    updateOpenLevel(false)
                    return delay(150)
                })
                .then(() => {
                    updateNavigateToCensusDetail(true)
                    stackManager.addNewLevel('EquipmentDetailLevel', {id: jsonCensusEquipment?.equipmentInfo?.id})
                })
        }

        const eq: EquipmentWithSuggestedAndFinalAction = {
            code: <p className={"link"} onClick={onclick}>{valueOrDefault(equipment?.code)}</p>,
            name: valueOrDefault(equipment?.name),
            model: valueOrDefault(equipment?.model),
            location: valueOrDefault(equipment.location),
            since: valueOrDefault(
                getFormattedDate({dateToFormat: equipment?.since}),
            ),
            action: action,
            finalAction: valueOrDefault(
                translatedActionsEnum[jsonCensusEquipment.finalAction] ?? jsonCensusEquipment.finalAction),
        };
        return eq;
    });
};

export const createColumnsList = (
    getTableHeadersName: (name: EQ_TABLES_NAMES) => string,
): readonly Column<any>[] => {
    return [
        createColumnElement(
            getTableHeadersName(EQ_TABLES_NAMES.NAME),
            EQ_TABLES_INDEXES.NAME,
        ),
        createColumnElement(
            getTableHeadersName(EQ_TABLES_NAMES.CODE),
            EQ_TABLES_INDEXES.CODE,
        ),
        createColumnElement(
            getTableHeadersName(EQ_TABLES_NAMES.MODEL),
            EQ_TABLES_INDEXES.MODEL,
        ),
        createColumnElement(
            getTableHeadersName(EQ_TABLES_NAMES.LOCATION),
            EQ_TABLES_INDEXES.LOCATION,
        ),
        createColumnElement(
            getTableHeadersName(EQ_TABLES_NAMES.SINCE),
            EQ_TABLES_INDEXES.SINCE,
        ),
        createColumnElement(
            getTableHeadersName(EQ_TABLES_NAMES.ACTION),
            EQ_TABLES_INDEXES.ACTION,
        ),
        createColumnElement(
            getTableHeadersName(EQ_TABLES_NAMES.FINAL_ACTION),
            EQ_TABLES_INDEXES.FINAL_ACTION,
        ),
    ];
};

const createColumnElement = (
    title: string | EQ_TABLES_NAMES,
    dataIndex: string,
): Column<any> => {
    return {Header: title, accessor: dataIndex};
};
